import { ReactNode } from "react";
import { Modal } from "react-bootstrap";

export interface ConfirmModalProps {
  show: boolean;
  title?: string;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  variant?: "primary" | "danger" | "warning";
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal = ({
  show,
  title = "Xác nhận",
  message,
  confirmText = "Xác nhận",
  cancelText = "Hủy",
  variant = "danger",
  onConfirm,
  onCancel,
}: ConfirmModalProps) => {
  return (
    <Modal show={show} onHide={onCancel} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <button className="btn btn-light" onClick={onCancel}>
          {cancelText}
        </button>
        <button className={`btn btn-${variant}`} onClick={onConfirm}>
          {confirmText}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
